import React, { useRef } from 'react';
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS } from "@contentful/rich-text-types";

const options = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => {
			return <p className='text'>{children}</p>;
		},
	},
};

const HeaderSection = (props) => {
	const videoRef = useRef(null);

	const renderSectionMedia = () => {
		if (typeof window !== "undefined") {

			if (props.content.videoInsteadOfImage) {

				const imageBg = require("../../img/artboard--landing.jpg").default;
				let isMobile = /Android|iPhone|iPad/i.test(window.navigator.userAgent);

				const handleVideoEnded = () => {
					videoRef.current.currentTime = 2;
					videoRef.current.play();
				};

				return (
					<>
						{isMobile ? (
							<div>
								<img src={imageBg} alt='agoric' loading='eager' className={'w-100 pb-4'} />
							</div>
						) : (
							<div className='video-container'>
								<video
									id='home-video'
									src={props.content.image.url}
									autoPlay
									muted
									playsInline
									preload="true"
									type='video/mp4'
									ref={videoRef}
									onEnded={handleVideoEnded}
								/>
							</div>
						)}
					</>
				);
			}

			return (
				<div className='z-0 order-1 col-right text-end order-md-2'>
					<link rel="preload"
						  as="image"
						  href={props.content?.image?.url}
						  imageSrcSet={`${props.content?.image?.url} 800w`}/>
					<div className={"image"}>
						<img src={props.content?.image?.url} alt={props.content.title} />
					</div>
				</div>
			);
		}
	};

	return (
		<section key={props.content.id} className='header-section'>
			<div className='container'>
				<div className='row'>
					<div className='order-1 order-2 col-xl-6 col-md-6 col-sm-8 z-1'>
						<div className='row'>
							<div className='col-lg-10'>
								{props.content.smallTitle &&
									<div className={'h1-subtitle'}>{props.content.smallTitle}</div>
								}
								<h1 dangerouslySetInnerHTML={{__html: props.content.title}}></h1>
							</div>
						</div>
						<div className='row'>
							<div className='col-lg-8 text'>{renderRichText(props.content.body, options)}</div>
						</div>
						{props.content.ctaText && (
							<div className='row actions'>
								<div className='col-lg-12'>
									<a href={props.content.ctaUrl} className='btn' target={props.content.isExternal ? '_blank' : '_self'}>
										{props.content.ctaText}
									</a>
									{props.content.secondaryCtaUrl && (
										<a href={props.content.secondaryCtaUrl} className='more' target={props.content.isSecondaryExternal ? '_blank' : '_self'}>
											<i className='fas fa-arrow-right' />
											{props.content.secondaryCtaText}
										</a>
									)}
								</div>
							</div>
						)}
					</div>
					{renderSectionMedia()}
				</div>
			</div>
		</section>
	);
};

export default HeaderSection;
